import request from "./base";
const path = "/api/tasks";

export default {
  getById: function (id) {
    return request().get(path + "/" + id);
  },
  delete: function(params) {
    return request().delete(path + "/", {
      data: params
    });
  },
  makeTodo: function(params) {
    return request().post(path + "/make-todo", params);
  },
  copyToJob: function(params) {
    return request().post(path + "/copy", params);
  },
};
